import React, { Component } from "react"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import Box from "@material-ui/core/Box"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import axios from "axios"

import * as constants from "../constants"
const styles = (theme) => ({
      paper: {
            marginTop: theme.spacing(8),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
      },
      form: {
            width: "100%", // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            direction: "ltr",
      },
      label: {
            direction: "rtl",
            width: "100%", // Fix IE 11 issue.
      },
      submit: {
            margin: theme.spacing(3, 0, 2),
      },
})

class ChangePass extends Component {
      cookies = new Cookies()

      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  oldpass: "",
                  newpass: "",
                  renewpass: "",
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  temp: null,
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")
                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      handleChangeOldpass = (event) => {
            this.setState({ oldpass: event.target.value })
      }

      handleChangeNewpass = (event) => {
            this.setState({ newpass: event.target.value })
      }

      handleChangeReNewpass = (event) => {
            this.setState({ renewpass: event.target.value })
      }

      submit = (e) => {
            const { oldpass, newpass, renewpass } = this.state
            if (newpass === "") {
                  this.setState({ errstr: "رمز عبور جدید را وارد نمایید.", errstatus: true, okstatus: false })
            } else {
                  if (newpass === renewpass) {
                        this.props.props.dispatch({
                              type: "WAITSHOW",
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({ errstr: arr.desc, errstatus: false, okstatus: true })
                                          //self.setState({ redirect: true })
                                    } else if (arr.result === "error") {
                                          self.setState({ errstr: arr.desc, errstatus: true, okstatus: false })
                                    }
                                    self.props.props.dispatch({
                                          type: "WITEHIDE",
                                    })
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "changepass")
                        fd.append("employee_pass", oldpass)
                        fd.append("employee_newpass", newpass)
                        xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                        //    xhttp.setRequestHeader('employeetoken', 'Bearer ');
                        xhttp.send(fd)

                        /*  var fd = new FormData();
  fd.append('command', 'changepass' );
  fd.append('employee_pass',oldpass );
  fd.append('employee_newpass', newpass );

  var self = this;

axios({
    method: 'post',
    url: 'https://api.rahnamayefarda.ir/api/employeelogin',
    data: fd,
    headers: {'Content-Type': 'multipart/form-data' ,'Employeetoken':'32244234234'}
    })
    .then(function (response) {
      console.log(response);
      if (response.statusText=== "ok" && response.status === 200) {
          var arr = response.data;
          console.log(arr);
          if(arr.result==='ok'){

           self.setState({ errstr: arr.desc,errstatus:false,okstatus:true });
//self.setState({ redirect: true })

         }else if(arr.result==='error'){
        self.setState({ errstr: arr.desc,errstatus:true,okstatus:false });
         }
         self.props.props.dispatch({
            type : 'WITEHIDE',
          })

       }
    })
    .catch(function (response) {
        //handle error
        console.log(response);
    });
*/
                  } else {
                        this.setState({ errstr: "رمز عبور جدید با تکرار آن برابر نیستند", errstatus: true, okstatus: false })
                  }
            }
      }

      render() {
            const { classes } = this.props
            const { okstatus, errstr, oldpass, newpass, renewpass, errstatus, redirect } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <Container>
                              <Container component="main" maxWidth="xs">
                                    <CssBaseline />
                                    <div className={classes.paper}>
                                          <Avatar className={classes.avatar}>
                                                <LockOutlinedIcon />
                                          </Avatar>
                                          <Typography component="h1" variant="h5">
                                                تغییر رمز عبور
                                          </Typography>
                                          <form className={classes.form} noValidate>
                                                <TextField
                                                      variant="outlined"
                                                      margin="normal"
                                                      required
                                                      fullWidth
                                                      id="oldpass"
                                                      label="رمز قدیم"
                                                      type="password"
                                                      name="oldpass"
                                                      autoComplete="oldpass"
                                                      autoFocus
                                                      value={oldpass}
                                                      onChange={this.handleChangeOldpass}
                                                />
                                                <TextField
                                                      variant="outlined"
                                                      margin="normal"
                                                      required
                                                      fullWidth
                                                      id="newpass"
                                                      label="رمز جدید"
                                                      type="password"
                                                      name="newpass"
                                                      autoComplete="newpass"
                                                      value={newpass}
                                                      onChange={this.handleChangeNewpass}
                                                />
                                                <TextField
                                                      variant="outlined"
                                                      margin="normal"
                                                      required
                                                      fullWidth
                                                      type="password"
                                                      id="renewpass"
                                                      label=" تکرار رمز جدید"
                                                      name="renewpass"
                                                      autoComplete="renewpass"
                                                      value={renewpass}
                                                      onChange={this.handleChangeReNewpass}
                                                />

                                                <Button
                                                      onClick={this.submit}
                                                      fullWidth
                                                      variant="contained"
                                                      color="primary"
                                                      className={classes.submit}
                                                >
                                                      تغییر رمز
                                                </Button>
                                          </form>
                                    </div>
                                    <Box mt={8}></Box>
                              </Container>
                              {errstatus ? (
                                    <Alert severity="error">
                                          <AlertTitle>خطا</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </Container>
                  )
            }
      }
}

export default withStyles(styles)(ChangePass)
